<div class="card mb-5">

  <div class="card-header">

    <h3>
      Facturas pendientes de anulación
    </h3>

  </div>

  <div class="card-body">

    <div class="row">

      <div class="col">

        <div class="d-flex justify-content-between align-items-center mb-3">

          <div>

            <!-- <span class="badge bg-warning text-dark">
              Pendientes:
              {{ invoices.length }}
            </span> -->

          </div>

          <!-- <button
            class="btn btn-primary"
            (click)="getInvoicesToAnul()"
            [disabled]="loadingData">

            <span
              *ngIf="loadingData"
              class="spinner-border spinner-border-sm"
              aria-hidden="true">
            </span>

            <i
              *ngIf="!loadingData"
              class="fa fa-rotate-right">
            </i>

            Actualizar

          </button> -->

        </div>


        <div class="table-responsive">

          <table class="table table-striped table-hover">

            <thead>

              <tr>

                <th class="ta">
                  ID
                </th>

                <th class="ta">
                  Serie
                </th>

                <th class="ta">
                  Número
                </th>

                <th class="ta">
                  Fecha
                </th>

                <th class="ta">
                  NIT
                </th>

                <th class="ta">
                  Cliente
                </th>

                <th class="ta">
                  Total
                </th>

                <th class="ta">
                  Acción
                </th>

              </tr>

            </thead>

            <tbody>

              <!-- CARGANDO -->
              <tr *ngIf="loadingData">

                <td
                  colspan="8"
                  class="text-center">

                  <app-loading-animation
                    [height]="'5rem'">
                  </app-loading-animation>

                  <p class="display-6">
                    Cargando...
                  </p>

                </td>

              </tr>


              <!-- FACTURAS -->
              <ng-container *ngIf="!loadingData">

                <tr
                  *ngFor="let invoice of pagination.filter">

                  <td class="ta">
                    {{ invoice.id }}
                  </td>

                  <td class="ta">
                    {{ invoice.series }}
                  </td>

                  <td class="ta">
                    {{ invoice.number }}
                  </td>

                  <td class="ta">
                    {{ convertToString(invoice.date) }}
                  </td>

                  <td class="ta">
                    {{ invoice.nit }}
                  </td>

                  <td class="ta">

                    {{
                      getFixedName(
                        invoice.clientData?.name ||
                        invoice.name ||
                        ''
                      )
                    }}

                  </td>

                  <td class="ta">

                    {{
                      getInvoiceTotal(invoice)
                      | currency :
                      ((invoice.currency == 1) ? '$' : 'Q')
                    }}

                  </td>

                  <td class="ta">

                    <button
                      class="btn btn-warning btn-sm"
                      title="Anular factura"
                      (click)="anulateInvoice(invoice)">

                      <i class="fa fa-ban"></i>

                      Anular

                    </button>

                  </td>

                </tr>


                <!-- SIN RESULTADOS -->
                <tr *ngIf="invoices.length === 0">

                  <td
                    colspan="8"
                    class="ta text-muted">

                    <i class="fa fa-circle-check"></i>

                    No existen facturas pendientes de anulación.

                  </td>

                </tr>

              </ng-container>

            </tbody>

          </table>

        </div>


        <app-pagination-custom
          *ngIf="invoices.length > 0"
          [elements]="pagination">
        </app-pagination-custom>

      </div>

    </div>

  </div>


  <!-- FONDO MODAL -->
  <div
    class="hide-background"
    *ngIf="waitingFor">

    <div
      class="for-click"
      (click)="cancelAnulation()">
    </div>


    <!-- MODAL ANULACIÓN -->
    <div
      class="modal"
      tabindex="-1"
      *ngIf="seeingAnulate">

      <div class="modal-dialog">

        <div class="modal-content">

          <div class="modal-header">

            <div>

              <h1>
                ANULACIÓN DE FACTURA
              </h1>

              <small
                *ngIf="waitingFor"
                class="text-muted">

                {{ waitingFor.series }} -
                {{ waitingFor.number }}

              </small>

            </div>


            <h1
              style="left: 0;"
              class="i-hover">

              <i
                class="fa fa-xmark"
                (click)="cancelAnulation()">
              </i>

            </h1>

          </div>


          <div class="modal-body">

            <div
              *ngIf="waitingFor"
              class="alert alert-warning">

              <strong>
                Factura:
              </strong>

              {{ waitingFor.series }} -
              {{ waitingFor.number }}

              <br>

              <strong>
                NIT:
              </strong>

              {{ waitingFor.nit }}

              <br>

              <strong>
                Cliente:
              </strong>

              {{
                getFixedName(
                  waitingFor.clientData?.name ||
                  waitingFor.name ||
                  ''
                )
              }}

              <br>

              <strong>
                Total:
              </strong>

              {{
                getInvoiceTotal(waitingFor)
                | currency :
                ((waitingFor.currency == 1) ? '$' : 'Q')
              }}

            </div>


            <div class="form-group">

              <label
                for="reason"
                class="form-label">

                Razón de la anulación

                <span class="required">
                  *
                </span>

              </label>

              <textarea
                [(ngModel)]="cancelledDescription"
                placeholder="Ingresa una descripción para la factura a anular"
                name="reason"
                id="reason"
                cols="30"
                rows="6"
                class="form-control">
              </textarea>

            </div>

          </div>


          <div class="modal-footer">

            <button
              class="btn btn-primary"
              (click)="cancelAnulation()"
              [disabled]="anulating">

              <i class="fa fa-xmark"></i>

              CANCELAR

            </button>


            <button
              class="btn btn-warning"
              [disabled]="
                !cancelledDescription.trim() ||
                anulating
              "
              (click)="confirmCanceledInvoice()">

              <i
                *ngIf="!anulating"
                class="fa fa-ban">
              </i>

              <span
                *ngIf="anulating"
                class="spinner-border spinner-border-sm"
                aria-hidden="true">
              </span>

              ANULAR

            </button>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>